export interface RoleLike {
  key: string;
}

const RESERVATION_ONLY = new Set(['designer', 'sales']);
const RESERVATION_ACCESS = new Set(['admin', 'supervisor', 'designer', 'sales']);
const PRODUCT_EDITORS = new Set(['admin', 'supervisor']);

export function hasAnyRole(user: { roles?: RoleLike[] } | null | undefined, keys: string[]): boolean {
  return user?.roles?.some((r) => keys.includes(r.key)) ?? false;
}

export function isAdmin(user: { roles?: RoleLike[] } | null | undefined): boolean {
  return hasAnyRole(user, ['admin']);
}

export function isReservationOnly(user: { roles?: RoleLike[] } | null | undefined): boolean {
  const roles = user?.roles ?? [];
  return roles.length > 0 && roles.every((r) => RESERVATION_ONLY.has(r.key));
}

export function canAccessReservations(user: { roles?: RoleLike[] } | null | undefined): boolean {
  return user?.roles?.some((r) => RESERVATION_ACCESS.has(r.key)) ?? false;
}

export function canEditProducts(user: { roles?: RoleLike[] } | null | undefined): boolean {
  return user?.roles?.some((r) => PRODUCT_EDITORS.has(r.key)) ?? false;
}

export function isAdminFromStorage(): boolean {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return false;
    return isAdmin(JSON.parse(raw) as { roles?: RoleLike[] });
  } catch {
    return false;
  }
}

export function readStoredUser(): { roles?: RoleLike[] } | null {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) as { roles?: RoleLike[] } : null;
  } catch {
    return null;
  }
}
